<template>
   <section class="about__area pt-130 pb-125" id="whyarea">
      <div class="container">
         <div class="row">
            <div class="col-xxl-5 col-xl-6 col-lg-6 mt-50">
               <div class="about__thumb-wrapper">

                  <div class="about__review">
                     <h5> <span>Imagens </span>CCI - UFDPar</h5>
                  </div>
                  <div class="about__thumb ml-100">
                     <img src="../../assets/img/about/about.jpg" alt="">
                  </div>
                  <div class="about__banner mt--210">
                     <img src="../../assets/img/about/about-banner.jpg" alt="">
                  </div>
                  <div class="about__student ml-270 mt--80">
                     <a href="#">
                        <img src="../../assets/img/about/estudante-1.jpg" alt="">
                        <img src="../../assets/img/about/estudante-3.jpg" alt="">
                        <img src="../../assets/img/about/estudante-2.jpg" alt="">
                        <img src="../../assets/img/about/estudante-4.jpg" alt="">
                     </a>
                     <p>Mais de <span>1900+</span> egressos</p>
                  </div>
               </div>
            </div>
            <div class="col-xxl-7 col-xl-7 col-lg-7">
               <div class="about__content pl-70 pr-60 ">
                  <div class="section__title-wrapper mb-25">
                     <h2 class="section__title">Acompanhamento <br><span class="yellow-bg-big">Egressos <img
                              src="../../assets/img/shape/yellow-bg-2.png" alt="">
                        </span> UFDPar </h2>
                     <p>O sucesso de nossos egressos expressam nosso êxito enquanto instituição formadora, por esse
                        motivo, precisamos manter com você, que concluiu a graduação e pós-graduação na Universidade
                        Federal do Delta do Parnaíba, um relacionamento contínuo, vivo.</p>

                     <p>A plataforma de egressos tem esse objetivo maior: de continuidade de nossa história! Este é o
                        espaço de diálogo no qual buscamos conhecer sua trajetória após a conclusão de curso e promover
                        o acesso à formação continuada e desenvolvimento profissional; avaliar nossos cursos de
                        graduação e pós-graduação, políticas educacionais e nossa capacidade de atendimento às demandas
                        sociais. Importante também promovermos a aproximação e articulação entre nossos egressos e
                        discentes dos cursos de graduação e programas de pós-graduação no sentido de avançarmos nas
                        melhorias de nossas políticas, currículos, estratégias e ações educativas.
                     </p>
                     <p>
                        Esse espaço possibilita ainda informar à sociedade os resultados alcançados pela UFDPar enquanto
                        instituição formadora.</p>
                     <p>

                     </p>
                  </div>
                  <div class="about__list mb-35">
                     <ul>

                        <li class="d-flex align-items-center"> Neste sentido, convidamos a
                           responder o Questionário do Egresso disponível nesta plataforma.
                           Este espaço é seu! Contribua com sua construção.</li>
                     </ul>
                  </div>
                  <router-link to="/questionario" class="e-btn e-btn-border">Acessar</router-link>
               </div>
            </div>
         </div>
      </div>
   </section>

</template>

<script>
export default {
   name: 'WhyArea',
};
</script>
<style scoped>
.mt-50 {
   margin-top: 50px;
}

/* Anula a mt-50 em telas de até 576px */
@media (max-width: 576px) {
   .mt-50 {
      margin-top: 0 !important;
   }
}
</style>